import { CollectionStatusEnum, } from "../types/Api";
var ISSN_INPUT = /^(\d{4})\s*-?\s*(\d{3}[\dX])$/;
/**
 * Display name of an edition or a Series (DB-787, NKP #747): the name together with the ISSN register qualifier
 * (222 $b), e.g. "Edice X (Print)", "Ročenka Y (Online)". A qualifier that already carries its parentheses is
 * appended as is.
 * Exports (Aleph 830 $a, ONIX) keep the plain mainName - this is for display only.
 */
export var formatCollectionName = function (collection) {
    var _a, _b, _c;
    var name = (_b = (_a = collection === null || collection === void 0 ? void 0 : collection.mainName) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : "";
    if (!name)
        return "";
    var qualifier = (_c = collection === null || collection === void 0 ? void 0 : collection.qualifier) === null || _c === void 0 ? void 0 : _c.trim();
    if (!qualifier)
        return name;
    return qualifier.startsWith("(")
        ? "".concat(name, " ").concat(qualifier)
        : "".concat(name, " (").concat(qualifier, ")");
};
/** Whether the ISSN register marks the edition as ceased (008/06 = d). */
export var isCeasedCollection = function (collection) { return (collection === null || collection === void 0 ? void 0 : collection.status) === CollectionStatusEnum.CEASED; };
/**
 * Status of an edition for display: "ukončená (2019)" for a ceased one with an end year, the translated
 * status otherwise; empty for an unknown status.
 */
export var formatCollectionStatus = function (collection, formatMessage) {
    var status = collection === null || collection === void 0 ? void 0 : collection.status;
    if (!status || status === CollectionStatusEnum.UNKNOWN)
        return "";
    if (status === CollectionStatusEnum.CEASED && (collection === null || collection === void 0 ? void 0 : collection.endYear)) {
        return formatMessage({ id: "ui-br-agency.collections.status.ceasedInYear" }, { year: collection.endYear });
    }
    return formatMessage({ id: "ui-br-agency.collections.status.".concat(status) });
};
/** Translated publication medium of an edition; empty when unknown. */
export var formatCollectionMedium = function (medium, formatMessage) {
    return medium
        ? formatMessage({ id: "ui-br-agency.collections.medium.".concat(medium) })
        : "";
};
/**
 * Canonical NNNN-NNNC form of an ISSN typed with or without the hyphen (the backend stores this form);
 * a value that is not an ISSN is only trimmed.
 */
export var normalizeIssn = function (value) {
    var trimmed = value.trim();
    var match = ISSN_INPUT.exec(trimmed.toUpperCase());
    return match ? "".concat(match[1], "-").concat(match[2]) : trimmed;
};
/**
 * Label of an edition or a Series wherever it is listed for a title or offered for selection: the display name, and for
 * a ceased edition its status with the end year, e.g. "Edice X (Print) – ukončená v roce 2019".
 */
export var formatCollectionOptionLabel = function (collection, formatMessage) {
    var name = formatCollectionName(collection);
    if (!isCeasedCollection(collection))
        return name;
    return "".concat(name, " \u2013 ").concat(formatCollectionStatus(collection, formatMessage));
};
